import type { FC } from 'react';
import { createContext, useContext } from 'react';
import { DEFAULT_LOCALE } from '@epic-mw/localization';
import type { LocalesUnion } from '@constants/i18n';

const LocaleContext = createContext<LocalesUnion>(DEFAULT_LOCALE as LocalesUnion);

export const useLocale = (): LocalesUnion => useContext(LocaleContext);

type LocaleProviderProps = {
  locale: LocalesUnion;
  children: React.ReactNode;
};

export const LocaleProvider: FC<LocaleProviderProps> = ({ locale, children }) => (
  <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
);
